import React, { useMemo, useState, useEffect } from "react";
import { formatIntDateTime } from "../../utils/dateUtils";

const ComponentWorkOrderSelectionModal = ({
  show,
  workOrders = [],
  onClose,
  onAddNew,
  onComplete,
  loading = false,
}) => {
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!show) {
      setSelectedId(null);
    }
  }, [show]);

  const selectedWorkOrder = useMemo(
    () => workOrders.find((wo) => wo.id === selectedId) || null,
    [selectedId, workOrders],
  );

  if (!show) {
    return null;
  }

  return (
    <div className="modal modal-backdrop show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Open Work Orders Found</h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={loading} />
          </div>
          <div className="modal-body">
            <div className="bg-warning-focus border border-warning p-16 mb-16 rounded-3">
              <strong>Existing Work Orders Found</strong><br />
              There are already open work orders for this component replacement.<br />
              Would you like to review and complete one of those instead of creating a new work order?
            </div>
            <div className="table-responsive" style={{ maxHeight: "400px" }}>
              <table className="table bordered-table mb-0 w-100 rounded-0">
                <thead>
                  <tr>
                    <th style={{ width: "50px" }}></th>
                    <th>Work Order Number</th>
                    <th>Title</th>
                    <th>Status</th>
                    <th>Scheduled At</th>
                    <th>Due Date</th>
                    <th>Started At</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={7} className="text-center py-4">
                        <span className="spinner-border text-primary" role="status" aria-hidden="true"></span>
                      </td>
                    </tr>
                  ) : workOrders.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center py-4">
                        No matching open work orders were found.
                      </td>
                    </tr>
                  ) : (
                    workOrders.map((workOrder) => {
                      const statusColour = workOrder.status?.colours?.bootstrapName || "secondary";
                      const isSelected = selectedId === workOrder.id;
                      return (
                        <tr key={workOrder.id} className={isSelected ? "table-active" : ""}>
                          <td>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => setSelectedId(isSelected ? null : workOrder.id)}
                                aria-label={`Select work order ${workOrder.workOrderNumber}`}
                                disabled={loading}
                              />
                            </div>
                          </td>
                          <td>{workOrder.workOrderNumber}</td>
                          <td>{workOrder.workOrderTitle}</td>
                          <td>
                            {workOrder.status && (
                              <span
                                className={`bg-${statusColour}-focus text-${statusColour}-main px-16 py-2 rounded-pill fw-medium text-sm`}
                              >
                                {workOrder.status.name}
                              </span>
                            )}
                          </td>
                          <td>{formatIntDateTime(workOrder.scheduledAt)}</td>
                          <td>{formatIntDateTime(workOrder.dueDate)}</td>
                          <td>{formatIntDateTime(workOrder.startedAt)}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="button" className="btn btn-success" onClick={onAddNew} disabled={loading}>
              Add a New Work Order
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => selectedWorkOrder && onComplete(selectedWorkOrder)}
              disabled={!selectedWorkOrder || loading}
            >
              {loading ? "Processing..." : "Complete Select Work Order"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentWorkOrderSelectionModal;
